/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sidebar_StatisticsInputs */

const en_admin_sidebar_statistics = /** @type {(inputs: Admin_Sidebar_StatisticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistics`)
};

const de_admin_sidebar_statistics = /** @type {(inputs: Admin_Sidebar_StatisticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiken`)
};

/**
* | output |
* | --- |
* | "Statistics" |
*
* @param {Admin_Sidebar_StatisticsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_sidebar_statistics = /** @type {((inputs?: Admin_Sidebar_StatisticsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sidebar_StatisticsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_sidebar_statistics(inputs)
	return en_admin_sidebar_statistics(inputs)
});